import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LuArrowLeft, LuSearchX } from "react-icons/lu";

// Unbekannte URLs: eigene Seite mit noindex statt Startseiten-Duplikat (Soft-404 vermeiden)
export default function NotFound() {
  return (
    <section className="section">
      <Helmet>
        <meta name="robots" content="noindex, follow" />
        <title>Seite nicht gefunden – edi-converter.de</title>
      </Helmet>
      <div className="container container-sm text-center">
        <span className="icon-tile icon-tile-lg"><LuSearchX size={24} aria-hidden="true" /></span>
        <h1 className="h2" style={{ marginTop: 16 }}>Seite nicht gefunden</h1>
        <p className="lead" style={{ marginTop: 10 }}>
          Diese Adresse gibt es nicht (mehr).
        </p>
        <div className="row row-center" style={{ marginTop: 28 }}>
          <Link to="/" className="btn btn-primary"><LuArrowLeft size={16} aria-hidden="true" /> Zur Startseite</Link>
          <Link to="/edi-konverter" className="btn btn-secondary">Zum EDI Konverter</Link>
        </div>
      </div>
    </section>
  );
}
